export const CloseButton = ({ color = 'black', onClick }) => {
  return (
    <button
      style={{
        width: 24,
        height: 24,
        border: 'none',
        background: 'transparent',
        cursor: 'pointer',
        padding: 0,
        display: 'flex',
        justifyContent: 'center',
      }}
      onClick={onClick}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 12.708L6.75372 17.954C6.66022 18.0476 6.54547 18.0976 6.40947 18.104C6.27364 18.1105 6.15256 18.0605 6.04622 17.954C5.93972 17.8476 5.88647 17.7297 5.88647 17.6002C5.88647 17.4707 5.93972 17.3528 6.04622 17.2465L11.2922 12.0002L6.04622 6.75397C5.95256 6.66047 5.90256 6.54572 5.89622 6.40972C5.88972 6.27389 5.93972 6.1528 6.04622 6.04647C6.15256 5.93997 6.27047 5.88672 6.39997 5.88672C6.52947 5.88672 6.64739 5.93997 6.75372 6.04647L12 11.2925L17.2462 6.04647C17.3397 5.9528 17.4545 5.9028 17.5905 5.89647C17.7263 5.88997 17.8474 5.93997 17.9537 6.04647C18.0602 6.1528 18.1135 6.27072 18.1135 6.40022C18.1135 6.52972 18.0602 6.64764 17.9537 6.75397L12.7077 12.0002L17.9537 17.2465C18.0474 17.34 18.0974 17.4547 18.1037 17.5907C18.1102 17.7266 18.0602 17.8476 17.9537 17.954C17.8474 18.0605 17.7295 18.1137 17.6 18.1137C17.4705 18.1137 17.3526 18.0605 17.2462 17.954L12 12.708Z"
          fill={color}
          fillOpacity="0.6"
        />
      </svg>
    </button>
  )
}
